import React from 'react';
import { IconProps } from '../types/types';

const ONT: React.FC<IconProps> = (props) => (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300" role="img" {...props}><path d="M50.71 64.443 12 24v138c0 35.349 12.854 70.698 38.71 97.557 51.566 53.873 135.341 53.873 186.907 0L50.711 64.443ZM249.289 259.557 288 300V162c0-35.349-12.854-70.698-38.711-97.558-51.565-53.872-135.34-53.872-186.906 0L249.29 259.558Z" fill="#48A3FF"/></svg>
);

export default ONT;
